(function(window) {
    'use strict'

    const internal = window.RTAnalyticsInternal

    function createYandexGoal(target, goalId) {
        return {
            version: 1,
            routes: [{
                id: 'yandex-metrika-goal',
                provider: 'yandexMetrika',
                action: 'goal',
                map: function(event, config) {
                    const providerConfig = config.getProviderConfig('yandexMetrika')
                    if (!providerConfig.counterId) {
                        return null
                    }

                    return {
                        recipient: {
                            counterId: providerConfig.counterId
                        },
                        payload: {
                            target: target,
                            goalId: goalId || null,
                            params: event.payload.params || {}
                        }
                    }
                }
            }]
        }
    }

    internal.router.defineEvent('contacts.phone', createYandexGoal('contact-phone'))
    internal.router.defineEvent('contacts.email', createYandexGoal('contact-mail'))
    internal.router.defineEvent('certificates.clickToPay', createYandexGoal('certificate_click2pay'))
    internal.router.defineEvent('popupBanner.view', createYandexGoal('popup-banner__view', 604346177))
    internal.router.defineEvent('popupBanner.click', createYandexGoal('popup-banner__click', 604346179))
})(window)
